import React, {useEffect, useState} from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import CookieConsent from "react-cookie-consent";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import {UserAuthContextProvider} from "./context/UserAuthContext";
import SignUp from "./views/auth/SignUp";
import ForgotPassword from "./views/auth/ForgotPassword";
import Verification from "./views/auth/Verification";
import SignIn from "./views/auth/SignIn";
import DeleteAccount from "./views/auth/DeleteAccount";
import SessionTimeoutProvider from "./context/SessionTimeoutProvider";
import CookieBanner from "./components/cookie/CookieBanner";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from "./ProtectedRoute";

const App = () => {
    const [themeApp, setThemeApp] = useState({
        "--background-100": "#FFFFFF",
        "--background-900": "#070f2e",
        "--shadow-100": "rgba(112, 144, 176, 0.08)",
        "--color-50": "#E9E3FF",
        "--color-100": "#C0B8FE",
        "--color-200": "#A195FD",
        "--color-300": "#8171FC",
        "--color-400": "#7551FF",
        "--color-500": "#422AFB",
        "--color-600": "#3311DB",
        "--color-700": "#2111A5",
        "--color-800": "#190793",
        "--color-900": "#11047A",
    });
    const [mini, setMini] = useState(false);

    // When the theme state changes, this effect will update the CSS variables in the document's root element
    useEffect(() => {
        let color;
        for (color in themeApp) {
            document.documentElement.style.setProperty(color, themeApp[color]);
        }
        //eslint-disable-next-line
    }, [themeApp]);
    return (
        <UserAuthContextProvider>
            <SessionTimeoutProvider timeout={24 * 60 * 60 * 1000}>
                <CookieBanner/>

                <Routes>
                    <Route path="/auth/*" element={<AuthLayout/>}/>
                    {/*<Route path="/senze-2.0/auth/sign-up" element={<SignUp/>}/>
                <Route path="/senze-2.0/auth/sign-in" element={<SignIn/>}/>
                <Route path="/senze-2.0/auth/verify-otp" element={<Verification/>}/>
                <Route path="/senze-2.0/auth/reset-password" element={<ForgotPassword/>}/>*/}
                    <Route element={<ProtectedRoute/>}>
                        <Route
                            path="/admin/*"
                            element={
                                <AdminLayout
                                    setMini={setMini}
                                    mini={mini}
                                    theme={themeApp}
                                    setTheme={setThemeApp}
                                />
                            }
                        />
                    </Route>

                    <Route path="/rtl/*" element={<RtlLayout/>}/>
                    <Route path="/" element={<Navigate to="/auth/sign-in" replace/>}/>
                    <Route path="/auth/delete-account" element={<DeleteAccount/>}/>
                </Routes>
                <ToastContainer position="top-right" autoClose={3000}/>


            </SessionTimeoutProvider>
        </UserAuthContextProvider>

    );
};

export default App;
